import script from "./gift_time.vue?vue&type=script&setup=true&lang=js"
export * from "./gift_time.vue?vue&type=script&setup=true&lang=js"

import "./gift_time.vue?vue&type=style&index=0&id=1c6a1ec6&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\data_dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c6a1ec6"]])

export default __exports__